import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { EquipmentTypeDisplay, NodeBody, NodeContainer, NodeErrorIcon, NodeHeader } from '@/nodes/NodeUI';
import type { GuideNodeId } from '@rock/types';
import { outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import { type FC, useContext } from 'react';
import { FlowParamsContext } from '../app/FlowInitializer';
import type { EquipmentListNodeType } from './types';

export const EquipmentListNode: FC<NodeProps<EquipmentListNodeType>> = ({ id, selected, data }) => {
    const paths = outgoingHandles['equipment-list'](id as GuideNodeId, data);
    const { spaceId } = useContext(FlowParamsContext);

    return (
        <NodeContainer>
            <NodeErrorIcon id={id} />
            <NodeHeader id={id} type={data.type} title={data.pageTitle} />
            <NodeBody selected={selected}>
                <div className="flex flex-col items-stretch">
                    {data.onlyEquipmentTypeId && (
                        <div className="flex flex-row items-center justify-center gap-1 p-1 mt-2">
                            <span>Only:</span>
                            <EquipmentTypeDisplay spaceId={spaceId} typeId={data.onlyEquipmentTypeId} />
                        </div>
                    )}
                    <div className="p-1">Grouping: {data.grouping}</div>
                    <Separator className="my-2" />
                    <div className="flex flex-col items-center relative p-1">
                        <Button size="sm">{data.addLabel || 'Add Another'}</Button>
                        <Handle type="source" id={paths.addAnother} position={Position.Right} />
                    </div>
                    <div className="flex flex-col items-center relative p-1 mb-2">
                        <Button variant="link" size="sm">
                            {data.doneLabel || 'Done'}
                        </Button>
                        <Handle type="source" id={paths.done} position={Position.Right} />
                    </div>
                </div>
            </NodeBody>

            <Handle type="target" position={Position.Left} />
        </NodeContainer>
    );
};
